export default function () {
  return {
    notifications: [],
    searchValue: "",
  };
}
